// extracted by mini-css-extract-plugin
module.exports = {"image":"bA","image-placeholder":"bB","imagePlaceholder":"bB"};